<template>
  <div>
      <van-cell v-if="app.permission.op('charge_order_flag')" title="收费类型" to="/sf/set/type/list" is-link />
      <van-cell v-if="app.permission.op('achievement_belonger')" title="业绩归属人" to="/sf/set/belonger" is-link />
      <van-cell v-if="app.permission.op('receiptTemplateSet')" title="收据样式" to="/sf/set/receiptExample" is-link />
      <van-cell v-if="app.permission.op('company_merchant_list || campus_merchant_list')" title="线上支付收款商户" to="/sf/set/channel" is-link />
      <van-cell v-if="app.permission.op('payment_account_offline_custom_set')" title="线下收款账户" to="/sf/set/offline-channel" is-link />
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: '收费设置',
    };
  },
};
</script>

<style lang="scss" scoped>
</style>